/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmPictureFragment } from './CMPicture.fragment';
import { gql } from '@apollo/client';
import { CmPictureFragmentDoc } from './CMPicture.fragment';
export type CmPictureForCollectionFragment = (
  { __typename?: 'CMPictureImpl', storytellingSettings?: any | null }
  & CmPictureFragment
);

export const CmPictureForCollectionFragmentDoc = gql`
    fragment CMPictureForCollection on CMPicture {
  ...CMPicture
  storytellingSettings: settings(
    paths: ["storytelling.title.length", "storytelling.text.length", "quote.text.length"]
  )
}
    ${CmPictureFragmentDoc}`;